import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import {
  getActiveModal,
  getModalData, getHeading, getUser,
  isFetching,
  hasError,
} from '../../selectors/common';
import Section from '../../components/Section';
import Loader from '../../components/Loader';
import Menu from '../Menu';
import ErrorModal from '../../components/Modals/ErrorModal';
import SuccessModal from '../../components/Modals/SuccessModal';
import { MODALS, PAGES } from '../../constants';
import { aLogout } from '../../reducers';
import { aSetOpenModal } from '../../reducers/common';

const Main = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector(getUser);
  const isFetchingStore = useSelector(isFetching);
  // const selectedMenuItem = useSelector(getSelectedMenuItem);
  const hasErrorStore = useSelector(hasError);
  const activeModal = useSelector(getActiveModal);
  const modalData = useSelector(getModalData);
  const heading = useSelector(getHeading);

  const setOpenModal = (payload) => dispatch(aSetOpenModal(payload));
  const logout = (payload) => dispatch(aLogout(payload));

  useEffect(() => {
    if (!user) {
      navigate(PAGES.LOGIN);
    }
  });

  const getFetchStatus = () => {
    const fetchStatusArr = Object.keys(isFetchingStore);
    if (fetchStatusArr.length > 0) return false;
    return true;
  };

  return (
    <>
      <Menu
        navigate={navigate}
        location={location}
      />
      <div className="content">
        <div className="content__wrapper">
          <Section
            heading={heading}
          >
            {!getFetchStatus() && <Loader />}
            <Outlet />
          </Section>
        </div>
      </div>
      {hasErrorStore && (
        <div className="modal modal--open">
          <ErrorModal
            message={hasErrorStore}
            setOpenModal={setOpenModal}
            modal={activeModal}
            logout={logout}
          />
        </div>
      )}

      {activeModal === MODALS.SUCCESS
        && (
          <div className="modal modal--open">
            <SuccessModal
              modalData={modalData}
              setOpenModal={setOpenModal}
            />
          </div>
        )}
      {activeModal
        && <div className="overlay-mask overlay-mask--open" />}
    </>
  );
};

export default Main;
